// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../node_modules/postcss-loader/src/index.js!../../node_modules/sass-loader/dist/cjs.js!@css/utils");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./login-header.png");
var ___CSS_LOADER_URL_IMPORT_1___ = require("./login-xi-bg.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.id, "html,body,._2jgAulfPx{min-height:100vh}body[consent-visible] ._2jgAulfPx{min-height:calc(100vh - 46px)}body{margin:0px;display:flex;font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Helvetica,Ubuntu,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\";flex-direction:column}#app,.cc-banner{flex:1}._2jgAulfPx{background-color:#0F1D51;display:flex;flex-direction:column}@media (min-width: 1100px){._2jgAulfPx{flex-direction:row}}._5v4MHvkBx{display:flex;justify-content:center;height:80px;background-color:#0F1D51;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-repeat:no-repeat;background-position:center}@media (min-width: 1100px){._5v4MHvkBx{display:none}}._2MA254gGx{max-width:375px;width:100%;display:flex;margin:0px 32px}._3w30HaNRx{width:140px}._6ImfX3d4x{position:relative;flex:0 1 auto;width:100%;padding:40px;background-color:#0F1D51;color:#ffffff;box-sizing:border-box;display:none}@media (min-width: 1100px){._6ImfX3d4x{display:flex;flex-direction:column;justify-content:space-between}}._6ImfX3d4x._53QK6mWax{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ");background-color:#4EA1E6}._6ImfX3d4x._3cFQxzuwx{background-image:none}._4rdsg2fxx{display:flex;flex-direction:column}._5jriroY9x{margin:20px 20px 10px 20px}._6cx6bXdEx{margin:0px 20px 10px 20px}.tHHwKWgZx{margin-top:10px;min-height:280px;max-height:calc(100vh - 270px)}._4NgctJhvx{background-color:#ffffff;margin:0;border-radius:0;flex:1 0 100%;display:flex;justify-content:center;padding:32px;box-sizing:border-box}@media (min-width: 1100px){._4NgctJhvx{margin:20px;border-radius:6px;flex:0 0 550px;padding:40px}}@media screen and (min-width: 1100px) and (-ms-high-contrast: active){._4NgctJhvx{border-left:1px solid buttonText}}@media (max-width: 1100px){._4NgctJhvx{background-color:var(--gray-light3)}}@media (max-width: 767px){._4NgctJhvx{padding:16px}}._4Bfk16ptx{display:flex;flex-direction:column;justify-content:space-between;max-width:375px;width:100%}@media (min-width: 1100px){._4Bfk16ptx{max-width:none}}@media (max-width: 1100px){body[consent-visible] ._4Bfk16ptx{height:70vh}}.IOByNzpax{margin:0px 20px 20px 20px;width:180px}._7vveENcyx{margin-bottom:40px;height:35px}@media (min-width: 340px){._7vveENcyx{height:40px}}._58bBZzDlx{padding:12px 12px 12px 0}._48Aw1dv8x{flex:1 0 auto;display:flex;flex-direction:column}._1gJCThRLx{padding:10px 0;box-sizing:border-box}._1gJCThRLx>*{flex:0 0 auto}._5HT8O6VRx{display:flex;box-sizing:border-box}._5HT8O6VRx>*{font-size:12px;line-height:16px}._5HT8O6VRx a{color:var(--secondary-text);text-decoration:none;margin-left:16px}._5HT8O6VRx a:first-child{margin-left:0}._5HT8O6VRx>._1mWyPc1Lx{flex:1 0 auto;text-align:end;display:block}._16Sudhfix{margin-top:10px}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"login-shell": "_2jgAulfPx",
	"loginShell": "_2jgAulfPx",
	"banner": "_5v4MHvkBx",
	"banner-logo": "_2MA254gGx",
	"bannerLogo": "_2MA254gGx",
	"banner-icon": "_3w30HaNRx",
	"bannerIcon": "_3w30HaNRx",
	"left-col": "_6ImfX3d4x",
	"leftCol": "_6ImfX3d4x",
	"from-xamarininsights": "_53QK6mWax",
	"fromXamarininsights": "_53QK6mWax",
	"none": "_3cFQxzuwx",
	"left-col-wrapper": "_4rdsg2fxx",
	"leftColWrapper": "_4rdsg2fxx",
	"header": "_5jriroY9x",
	"subheader": "_6cx6bXdEx",
	"hero-img": "tHHwKWgZx",
	"heroImg": "tHHwKWgZx",
	"right-col": "_4NgctJhvx",
	"rightCol": "_4NgctJhvx",
	"right-col-wrapper": "_4Bfk16ptx",
	"rightColWrapper": "_4Bfk16ptx",
	"login-logo": "IOByNzpax",
	"loginLogo": "IOByNzpax",
	"logo": "_7vveENcyx",
	"padded-icon": "_58bBZzDlx",
	"paddedIcon": "_58bBZzDlx",
	"login-form": "_48Aw1dv8x",
	"loginForm": "_48Aw1dv8x",
	"footer": "_1gJCThRLx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["stretch"] + " " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["vertically-center"] + "",
	"links-area": "_5HT8O6VRx",
	"linksArea": "_5HT8O6VRx",
	"copyright-on-the-right": "_1mWyPc1Lx",
	"copyrightOnTheRight": "_1mWyPc1Lx",
	"invitation-text": "_16Sudhfix",
	"invitationText": "_16Sudhfix"
};
module.exports = exports;
